import { render } from "./Externa.vue?vue&type=template&id=a95913b6"
import script from "./Externa.vue?vue&type=script&lang=js"
export * from "./Externa.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__